<template>
  <div class="quotation-search">
    <form @submit.prevent="submitForm">
      <div class="form">
        <div class="row">

          <div class="col-12">
            <div class="container block-box py-1">
              <div class="form-group privilage-group">
                <label>Оберіть продукт</label>
                <div class="radiolist mt-3">
                  <div v-for="product in quotationTypes" :key="product.id" class="radioitem">
                    <input
                      type="radio"
                      :id="'product-' + product.id"
                      :value="product"
                      v-model="selectedQuotation"
                      :checked="selectedQuotation"
                      :disabled="isDraftMode"
                      @change="loadProduct(product, product.id)"
                    >
                    <label :for="'product-' + product.id">
                      {{ product.name }}
                    </label>
                    <div class="check"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="container block-box mt-4">
              <div class="row">

                <div v-if="fields.length" v-for="field in getMainFields" :key="field.id" class="col-lg-6">
                  <div class="form-group">
                    <label>
                      {{ field.label }}
                      <span v-if="field.is_required" class="required-icon">*</span>
                    </label>

                    <!-- INPUT  , {invalid: (!$v.formValues[field.id].required && submitForm) } -->
                    <input
                      v-if="field.type === 'input'"
                      type="text"
                      :placeholder="getPlaceholder(field)"
                      :class="['form-control', {invalid: field.is_required && ( submitForm && !$v.formValues[field.id].required ) }]"
                      v-model="formValues[field.id]"
                    />

                    <!-- SELECT -->
                    <multiselect
                      v-else-if="field.type === 'select'"
                      v-model="formValues[field.id]"
                      :options="field.options"
                      :class="['form-control', {invalid: field.is_required && ( submitForm && !$v.formValues[field.id].required ) }]"
                      :placeholder="getPlaceholder(field)"
                      :searchable="false"
                      :allow-empty="false"
                      :max-height="120"
                      aria-label="pick a value"
                      :show-labels="false"
                      @select="selectItem"
                      >
                    </multiselect>

                    <!-- CHECKBOX -->
                    <div v-else-if="field.type === 'checkbox'" class="quotation-checkbox form-group">
                      <input
                        v-model="formValues[field.id]"
                        type="checkbox"
                        :name="'checkbox_'+field.id"
                      >
                    </div>
                    <div v-else-if="field.type === 'radio'" class="radiolist">
                      <div v-for="option in field.options" :key="option" class="radioitem">
                        <input
                          type="radio"
                          :id="'radio_'+field.id+'_'+option"
                          :name="'radio_'+field.id"
                          :value="option"
                          v-model="formValues[field.id]"
                        >
                        <label :for="'radio_'+field.id+'_'+option">
                          {{ option }}
                        </label>
                        <div class="check"></div>
                      </div>
                    </div>

                    <small class="error" v-if="field.is_required && ( submitForm && !$v.formValues[field.id].required )">
                      Поле обов'язкове
                    </small>

                  </div>
                </div>
              </div>

              <div class="row">
                <div v-if="fields.length && getFileFields.length" class="col-lg-12">
                  <label class="label-custom">Файли</label>
                </div>
                <div v-if="fields.length && getFileFields.length" class="col-lg-12 container">
                  <div class="col-lg-12 files-block">
                    <div class="row">
                      <div v-if="hasFileFields" v-for="field in getFileFields" :key="field.id" class="col-lg-6">
                        <div class="form-group">

                          <!-- если есть сохраненный файл -->
                          <div v-if="existingFiles[field.id]" class="existing-file d-flex align-center">
                            <SmartLink :url="'/storage/' + existingFiles[field.id]" target="_blank" class="file-link">
                              <svg style="margin-bottom: 5px;" width="16" height="16"
                                     viewBox="0 0 16 16" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                                  stroke="#24282C" stroke-width="2"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                                <path
                                  d="M4.6665 6.66666L7.99984 9.99999L11.3332 6.66666"
                                  stroke="#24282C" stroke-width="2"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8 10V2" stroke="#24282C" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              {{ field.label }} — переглянути
                            </SmartLink>
                            <DeleteButton @click="removeFile(field.id)"/>
                          </div>

                          <file-input
                            v-if="!existingFiles[field.id]"
                            v-model="formValues[field.id]"
                            :full-width="false"
                            @input="replaceFile($event, field.id)"
                          >
                            <template #button>
                              <div class="upload-link">
                                <ClipIcon :color="'#0A77FF'"/>
                                <span class="upload-link-word">{{ field.label }}</span>
                              </div>
                            </template>
                          </file-input>

                          <small class="error" v-if="!existingFiles[field.id] && field.is_required && ( submitForm && !$v.formValues[field.id].required )">
                            Поле обов'язкове
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Бажана СК</label>
                    <multiselect
                      multiple
                      v-model="company"
                      :options="companiesList"
                      :class="['form-control']"
                      placeholder="Виберіть бажану компанію"
                      :searchable="false"
                      :max-height="120"
                      aria-label="pick a value"
                      :show-labels="false"
                      label="company_name"
                      track-by="id"
                      @select="selectItem"
                    >
                    </multiselect>
                  </div>
                  <div class="form-group">
                    <label>Коментар</label>
                    <textarea
                      :class="['form-control']"
                      v-model="comment"
                      placeholder="Додайте нотаток">
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-center"></div>
        </div>

        <div class="row">
          <div class="col-12 mt-4">
            <div class="form-group__descr">Заповніть всі поля (<span class="shine-span">*</span>) щоб мати можливість скористатися пошуком</div>
          </div>
          <div class="col-lg-3 text-center">
            <button v-on:click="saveQuotation(true)" type="button" class="btn btn-outline-blue">
              Зберегти чернетку
            </button>
          </div>
          <div class="col-lg-3 text-center">
            <button type="button" class="btn btn-blue" @click="saveQuotation()">
              Відправити запит
            </button>
          </div>
        </div>
      </div>
    </form>
    <quotation-success-dialog :quotation="selectedQuotation" :quotationData="quotationData" :draft-status="isDraft" :dialog-visible.sync="showQuotationDialog"/>
  </div>
</template>

<script>

import {
  getQuotationTypes,
  getQuotation,
  createQuotationRequest,
  updateQuotationRequest,
  getQuotationRequest
} from "@/api/quotation";
import Multiselect from 'vue-multiselect';
import {required} from 'vuelidate/lib/validators';
import FileInput from '@/components/app/forms/FileInput.vue';
import QuotationSuccessDialog from "@/components/app/quotation/QuotationSuccessDialog.vue";
import Link from "../../../mixin/link";
import { ClipIcon, TrashIcon, DownloadIcon } from '@/shared/ui/icons';
import DeleteButton from "@/components/ui/DeleteButton.vue";
import { SmartLink } from '@/shared/ui/link';

export default {
  components: {SmartLink , Link, ClipIcon, TrashIcon, DownloadIcon, DeleteButton, Multiselect, FileInput, QuotationSuccessDialog },
  data() {
    return {
      quotationTypes: [],
      selectedQuotation: null,
      fields: [],
      formValues: {},
      companiesList: ['Оранта', 'Інго', 'Евроінс'],
      quotationData: null,
      submitForm: false,
      showQuotationDialog: false,
      isDraft: false,
      isDraftMode: false,
      draftId: null,
      comment: null,
      company: null,
      desiredCommission: null,
      existingFiles: {},
    };
  },
  computed: {
    getMainFields() {
      return this.fields.filter(i => i.type !== 'file');
    },
    getFileFields() {
      return this.fields.filter(i => i.type === 'file');
    },
    hasFileFields() {
      return this.getFileFields.length > 0;
    }
  },
  async mounted() {
    await this.loadQuotationTypes();
    if (this.$route.params.id) {
      await this.loadDraft(this.$route.params.id)
    } else {
      await this.initDefaultQuotation();
    }
  },
  validations() {
    let rules = {
      formValues: {}
    }

    if (!this.fields || !this.fields.length) {
      return rules;
    }

    this.fields.forEach(field => {
      if (field.type == 'file' && field.is_required && !this.existingFiles[field.id]) {
        rules.formValues[field.id] = { required }
      } else if (field.type !== 'file' && field.is_required) {
        rules.formValues[field.id] = { required }
      }
    });

    return rules;
  },
  watch: {
    fields: {
      deep: true,
      handler() {
        this.$v.$reset();
      }
    },
    existingFiles: {
      deep: true,
      handler() {
        this.$v.$reset();
      }
    },
  },
  methods: {
    getPlaceholder(field) {
      return 'Введіть ' + (field.label ? field.label.toLowerCase() : '');
    },
    selectItem(item) {

    },
    async loadQuotationTypes() {
      const { data } = await getQuotationTypes();
      this.quotationTypes = data;
    },

    async loadProduct(product, id) {
      const productCode = product.code ? product.code : '';
      const { data } = await getQuotation(id, productCode);
      this.submitForm = false;
      this.fields = data.fields;
      this.companiesList = data.companies;
      this.$emit('change-title', product.name);

      this.formValues = {};
      this.fields.forEach(field => {
        this.$set(this.formValues, field.id, null);
      });
    },
    async initDefaultQuotation() {
      if (!this.quotationTypes || !this.quotationTypes.length) {
        return;
      }
      let defaultProduct = this.quotationTypes.find(p => p.code === 'kasko');

      if (!defaultProduct) {
        defaultProduct = this.quotationTypes[0];
      }
      this.selectedQuotation = defaultProduct;

      await this.loadProduct(defaultProduct, defaultProduct.id);
    },
    async loadDraft(id) {
      const response = await getQuotationRequest(id);
      const quotationRequest = response.data.request;
      const quotationRequestValues = response.data.values;
      const quotationProduct = this.quotationTypes.find(quo => quo.id == quotationRequest.quotationTypeId);
      this.selectedQuotation = quotationProduct;
      await this.loadProduct(quotationProduct, quotationProduct.id);

      Object.keys(quotationRequestValues).forEach(fieldId => {
        if (this.formValues.hasOwnProperty(fieldId)) {

          const field = this.fields.find(f => f.id == fieldId)

          if (!field) return

          if (field.type === 'file') {
            this.$set(this.existingFiles, fieldId, quotationRequestValues[fieldId])
          } else {
            this.$set(this.formValues, fieldId, quotationRequestValues[fieldId])
          }
        }
      });
      // this.formValues = {
      //   ...this.formValues,
      //   ...quotationRequestValues
      // }

      this.draftId = quotationRequest.id;
      this.company = quotationRequest.company ? this.companiesList.filter(item => quotationRequest.company.includes(item.company_name) ) : null;
      this.comment = quotationRequest.comment;
      this.isDraftMode = true;
    },
    handleFileUpload(event, fieldId) {
      this.formValues[fieldId] = event.target.files[0];
    },
    removeFile(fieldId) {
      this.$delete(this.existingFiles, fieldId)
      this.$set(this.formValues, fieldId, null)
    },
    replaceFile(file, fieldId) {
      this.$set(this.formValues, fieldId, file)

      if (this.existingFiles[fieldId]) {
        this.$delete(this.existingFiles, fieldId)
      }
    },
    saveQuotationDraft() {
      this.isDraft = true;
      this.saveQuotation(true);
    },
    async saveQuotation(isDraft = false) {

      this.submitForm = true;

      if (!isDraft) {
        this.$v.$touch()

        if (this.$v.$invalid) {
          return false;
        }
      }

      const values = {}
      const files = {}
      const keepFiles = []

      Object.keys(this.formValues).forEach(fieldId => {
        const value = this.formValues[fieldId]

        if (value instanceof File) {
          files[fieldId] = value
          return
        }

        if (!value && this.existingFiles[fieldId]) {
          keepFiles.push(fieldId)
          return
        }

        values[fieldId] = value
      });

      let selectedCompanies = this.company && Array.isArray(this.company) ? this.company.map(i => i.company_name) : [];

      const paramsData = {
        draft_id: this.draftId,
        quotation_type_id: this.selectedQuotation.id,
        existingFiles: this.existingFiles,
        is_draft: isDraft,
        company: selectedCompanies ? selectedCompanies : null,
        comment: this.comment,
        values: values,
        files: files,
        keepFiles: keepFiles,
      }

      this.quotationData = this.formValues;

      createQuotationRequest(paramsData).then(({ data }) => {
        this.isDraft = isDraft;
        this.showQuotationDialog = true;
        this.submitForm = false;
        if (!this.draftId) {
          this.draftId = data.id
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import "../styles/quotations";
</style>
